import {post} from "./index";

export const platformServices = {
    setFunctionalityExtra: async (functionality, extra) => {
        return await post(`/platform/functionality/extra`, {functionality, extra});
    },
    saveCustomizablePopups: async (popups) => {
        return await post(`/platform/popups`, {popups});
    }
};
